import React, { useEffect } from "react";
import commonStyles from "../../Shared/commonStyles.module.css";
import styles from "./Hero.module.css";
import { Link } from "react-router-dom";
import useHighLightsStore from "../../../Stores/useHighLightsStore";

function Hero() {
  const { highlights, fetchHighlights } = useHighLightsStore();

  useEffect(() => {
    const fetchData = async () => {
      await fetchHighlights();
    };

    if (!highlights || highlights.length === 0) {
      fetchData();
    }
  }, []);

  // Keep your original shape: highlights[0].Items
  const sourceItems = highlights?.[0]?.Items ?? [];

  // Only require fields needed to render
  const visibleItems = sourceItems
    .filter((item) => item?.Link && item?.Image && item?.ProductName)
    .slice(0, 4);

  return (
    <section className={`${commonStyles.section} ${styles.hero}`}>
      <div className={`${commonStyles.container} ${styles.heroGrid}`}>
        <div className={styles.heroCopy}>
          <span className={commonStyles.eyebrow}>Jersey Premium Gifting</span>
          <h1>Thoughtful gifting that feels personal from start to delivery.</h1>
          <p>
            From meaningful personal gifts to beautifully presented hampers,
            Match Hampers helps you send the right gift quickly, thoughtfully,
            and with reliable local delivery.
          </p>

          <div className={styles.heroCtas}>
            <Link
              className={`${commonStyles.btn} ${commonStyles.btnPrimary}`}
              to="/products"
            >
              Browse Products
            </Link>
            <Link
              className={`${commonStyles.btn} ${commonStyles.btnSecondary}`}
              to="/occasions"
            >
              Shop by Occasions
            </Link>
          </div>

          <div className={styles.heroPoints}>
            <span>Personalised</span>
            <span>Wrapped</span>
            <span>Local Delivery</span>
            <span>Optional Alcohol Add-On</span>
          </div>
        </div>
        

        {visibleItems.length > 0 && (
          <aside className={styles.heroVisual} aria-label="Featured gifting tiles">
            <div className={styles.heroMosaic}>
              {visibleItems.map((item, index) => (
                <Link
                  key={`${item.Link}-${index}`}
                  to={item.Link}
                  className={`${index % 2 === 0 ? styles.tile : styles.tileAlt} ${styles.tileLink}`}
                >
                  <img src={item.Image} alt={item.AltText || item.ProductName} />
                  <strong>{item.ProductName}</strong>
                </Link>
              ))}
            </div>
          </aside>
        )}
      </div>
    </section>
  );
}

export default Hero;